module.exports = __webpack_public_path__ + "img/badge_eventi_main_level.4e6dd636.jpg";